import { render } from "./Watches.vue?vue&type=template&id=c2cbe23a"
import script from "./Watches.vue?vue&type=script&lang=js"
export * from "./Watches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__